<ng-container>
	<mat-card style="margin:20px;">
		<mat-card-header>
			<div style="font-size: 32px;font-weight: 900;">Articles</div>
		</mat-card-header>
		<mat-card-content>
			<div fxLayout="row" fxLayoutAlign="space-between">
				<mat-paginator #paginator (page)="Page($event)" [length]="count" [pageSize]="size">
				</mat-paginator>
				<button (click)="createDialog()" class="fab-center" color="primary" mat-fab>+</button>
			</div>
			<mat-grid-list (window:resize)="onResize($event)" [cols]="breakpoint" rowHeight="1:1">
				<mat-grid-tile *ngFor="let resource of results" [colspan]="resource.cols" [rowspan]="resource.rows" class="box-body">
					<mat-grid-tile-header>
						<div class="box-header">{{resource.id}}</div>
					</mat-grid-tile-header>

					<mat-grid-tile-footer fxLayout="row" fxLayoutAlign="space-around center">

						<button (click)="updateDialog(resource.id)" mat-icon-button>
							<mat-icon color="primary">edit</mat-icon>
						</button>
						<button (click)="onDelete($event, resource.id)" mat-icon-button>
							<mat-icon color="warn">delete_sweep</mat-icon>
						</button>

					</mat-grid-tile-footer>
				</mat-grid-tile>
			</mat-grid-list>
		</mat-card-content>
	</mat-card>
</ng-container>
